import { HiLoActivator as defaultOptions } from "./defaultOptionsForComputation";

const isValidNumber = (value) =>
  typeof value === "number" && Number.isFinite(value);

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    if (!Array.isArray(data) || data.length === 0) return [];

    const { highPeriod, lowPeriod } = options;
    const hp = Math.max(1, highPeriod || 1);
    const lp = Math.max(1, lowPeriod || 1);

    const highQueue = [];
    const lowQueue = [];
    let highSum = 0;
    let lowSum = 0;

    const mHighValues = new Array(data.length).fill(undefined);
    const mLowValues = new Array(data.length).fill(undefined);

    const results = new Array(data.length).fill(undefined);

    let lastLP = 0;

    for (let i = 0; i < data.length; i += 1) {
      const datum = data[i] || {};
      const high = datum.high;
      const low = datum.low;
      const close = datum.close;

      if (
        !isValidNumber(high) ||
        !isValidNumber(low) ||
        !isValidNumber(close)
      ) {
        continue;
      }

      highQueue.push(high);
      highSum += high;
      if (highQueue.length > hp) {
        highSum -= highQueue.shift();
      }

      lowQueue.push(low);
      lowSum += low;
      if (lowQueue.length > lp) {
        lowSum -= lowQueue.shift();
      }

      if (highQueue.length === hp) {
        mHighValues[i] = highSum / hp;
      }

      if (lowQueue.length === lp) {
        mLowValues[i] = lowSum / lp;
      }

      if (i === 0) {
        continue;
      }

      const prevMHigh = mHighValues[i - 1];
      const prevMLow = mLowValues[i - 1];
      const currentMHigh = mHighValues[i];
      const currentMLow = mLowValues[i];

      if (
        !isValidNumber(prevMHigh) ||
        !isValidNumber(prevMLow) ||
        !isValidNumber(currentMHigh) ||
        !isValidNumber(currentMLow)
      ) {
        continue;
      }

      let p = 0;
      if (close > prevMHigh) {
        p = 1;
      } else if (close < prevMLow) {
        p = -1;
      }

      let lpValue;
      if (p !== 0) {
        lpValue = p;
      } else if (lastLP !== 0) {
        lpValue = lastLP;
      } else {
        lpValue = 1;
      }

      lastLP = lpValue;

      const longStop = lpValue > 0 ? currentMLow : null;
      const shortStop = lpValue < 0 ? currentMHigh : null;

      results[i] = {
        P1: isValidNumber(longStop) ? longStop : null,
        P2: isValidNumber(shortStop) ? shortStop : null,
      };
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const { highPeriod, lowPeriod } = options;
    return Math.max(highPeriod || 1, lowPeriod || 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
